import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useMyContext } from "../../../myContext";
import CardDetail from "../../../common/CardDetails/CardDetail";
// import { CountryMapping } from "../../../utils";
import CommonButton from "../../CommonButton/CommonButton";

function VisitedBeneficiary({
  showBeneficiaryDetail,
  setShowBeneficiaryDetail,
  beneficiaryList,
  setShortDetail,
  setStepsToShow,
  setBeneficiaryBankCardSelection,
  beneficiaryCardSelection,
  setBeneficiaryCardSelection,
}) {
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const {
    beneficiaryUserId,
    setBeneficicaryUserId,
    setBeneficiaryBankSecondFlow,
    beneficiarySecondFlow,
    setCountryObject,
    setBeneficiaryBankId,
    CountryMapping,
  } = useMyContext();

  useEffect(() => {
    if (
      selectedBeneficiary &&
      selectedBeneficiary.userAccountId !== beneficiaryUserId
    ) {
      setBeneficiaryBankId(null);
      setBeneficicaryUserId(selectedBeneficiary.userAccountId);
    }
  }, [selectedBeneficiary]);

  const hanldeNextClick = () => {
    setShowBeneficiaryDetail(true);
    setBeneficiaryCardSelection(false);
    setBeneficiaryBankSecondFlow(true);
    // setBeneficicaryUserId(selectedBeneficiary.userAccountId);
    sessionStorage.setItem("beneficiaryName", selectedBeneficiary.fullName);
    setBeneficiaryBankCardSelection(true);
    setShortDetail({
      name: selectedBeneficiary.fullName,
      phone: selectedBeneficiary.phone,
      email: selectedBeneficiary.email,
      dob: selectedBeneficiary.dob,
      address: selectedBeneficiary.fullAddress,
      city: selectedBeneficiary.city,
      state: selectedBeneficiary.state,
      postalcode: selectedBeneficiary.postalCode,
      country: selectedBeneficiary.country,
      userAccountId: selectedBeneficiary.userAccountId,
    });
    setStepsToShow("BeneficiaryStep2");

    const selectedcountry = CountryMapping.find(
      (item) =>
        item.borderLessCountryName?.toLowerCase() ===
        selectedBeneficiary.country?.toLowerCase()
    );

    let countryObjectinString = JSON.stringify(selectedcountry);
    sessionStorage.setItem("country", countryObjectinString);
    if (selectedcountry) setCountryObject(selectedcountry);
    else setCountryObject(null);
  };

  return (
    <>
      {showBeneficiaryDetail === false && (
        <>
          <CardDetail
            cardlist={beneficiaryList}
            setSelectedValue={setSelectedBeneficiary}
            selectedValue={selectedBeneficiary}
            selectedUserid={beneficiaryUserId}
          />
          {beneficiaryCardSelection === true &&
            beneficiarySecondFlow === true && (
              <Row className="pt-3 mt-3">
                <CommonButton
                  title="Next"
                  onClick={hanldeNextClick}
                  loading={false}
                  disabled={selectedBeneficiary === null}
                  width={"150px"}
                />
              </Row>
            )}
        </>
      )}
    </>
  );
}

export default VisitedBeneficiary;
